import { IconAt, IconBrandWhatsapp, IconSun } from "@tabler/icons-react";
import ContactCardIcon from "../components/Help/ContactCardIcon";
import { emailTo } from "../utils/emailTo";
import { wappTo } from "../utils/wappTo";
import { useConfigContext } from "../contexts/ConfigContext/ConfigContextProvider";

const useContactCard = () => {
   const {jsonTexts} = useConfigContext();
   const texts = jsonTexts?.ayuda?.contactCard
   const { items: itemTexts} = texts


  const SUBJECT = texts?.subjectText;
  const MESSAGE = texts?.prevMessageText;

  const CONTACT_DATA = [
    {
      title: itemTexts?.email?.title,
      description: itemTexts?.email?.description,
      icon: IconAt,
      onClick: (to) => emailTo(to, SUBJECT),
    },
    {
      title: itemTexts?.cellphone?.title,
      description: itemTexts?.cellphone?.description,
      icon: IconBrandWhatsapp,
      onClick: (to) => wappTo(to.replace(/\s/g, ""), MESSAGE),
    },
    {
      title: itemTexts?.time?.title,
      info: itemTexts?.time?.info,
      description: itemTexts?.time?.description,
      icon: IconSun,
    },
  ];

  const generateContactItems = () => {
    return CONTACT_DATA.map((item, index) => (
      <ContactCardIcon key={index} {...item} />
    ));
  };

  return { generateContactItems };
};

export default useContactCard;
